import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseFooterController, FooterNavModule, LinkModule, SocialLinksModule } from '@ncg/ui';

@Component({
    selector: 'ncg-footer',
    template: `
        <footer class="footer">
            <ng-container *ngIf="navigationService.getNavigation() | async as items">
                <ncg-footer-nav class="section footer-top" [items]="items" *ngIf="items?.length"></ncg-footer-nav>
            </ng-container>

            <div class="section footer-bottom" *ngIf="settingsService.get() | async as settings">
                <div class="container is-flex">
                    <div class="footer-bottom__logo" *ngIf="settings.logoImageFooter?.url">
                        <ncg-link [link]="settings.logoLink ?? logoLink">
                            <img
                                loading="lazy"
                                class="footer-logo"
                                [attr.src]="settings.logoImageFooter?.url"
                                [attr.alt]="settings.logoImageFooter?.altText"
                                [attr.width]="settings.logoImageFooter?.width || null"
                                [attr.height]="settings.logoImageFooter?.height || null" />
                        </ncg-link>
                    </div>
                    <div class="footer-bottom__links" *ngIf="settings.footerLinks && settings.footerLinks.length">
                        <nav class="footer-bottom__navbar navbar">
                            <ncg-link
                                *ngFor="let link of settings.footerLinks"
                                [link]="link"
                                styleClass="footer-bottom__item footer-bottom__item--divider navbar-item"
                                >{{ link.name }}</ncg-link
                            >
                        </nav>
                        <div class="footer-bottom__copyright" *ngIf="settings.copyright">
                            <p>{{ settings.copyright }}</p>
                        </div>
                    </div>
                    <ncg-social-links
                        *ngIf="settings.socialLinks"
                        class="footer-bottom__social"
                        [socialLinks]="settings.socialLinks"></ncg-social-links>
                </div>
            </div>
        </footer>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, FooterNavModule, LinkModule, NgForOf, NgIf, SocialLinksModule],
})
export class FooterComponent extends BaseFooterController {}
